import axios from '../../../services/axios';
import { User } from '../types/UserData';


import { LoginRequest } from '../types/LoginRequest';
import { ForgotPasswordRequest } from '../types/ForgotPassword';
const login = (loginRequest: LoginRequest) => {
    return axios.post(`user/login`, loginRequest)
        .then((res: any) => {
            
            // let user: User = res.responseObject;
            return Promise.resolve(res);
        });
}

const forgotPassword = (email:ForgotPasswordRequest, host:any) => {
    return axios.put(`user/resetPassword`, {email,host})
        .then((res: any) => {
            let responseObj = res.responseObject;
            return Promise.resolve(responseObj);
        });
}

const resetPassword = (newPassword:any, passwordResetHash:any) => {
    return axios.put(`user/resetPasswordFinal`, {newPassword, passwordResetHash})
        .then((res: any) => {
            let responseObj = res.responseObject;
            return Promise.resolve(responseObj);
        });
}
const newPassword = (email:any) => {
    return axios.post(`user/resetPasswordFinal`, email)
        .then((res: any) => {
            let responseObj = res.responseObject;
            return Promise.resolve(responseObj);
        });
}

const teacherLogin = () => {
    return axios.post(`user/teacher-login`)
        .then((res: any) => {
            return Promise.resolve(res);
        });
}

const getTeacherToken = () => {
    return axios.get(`user/teacher-token`)
        .then((res: any) => {
            return Promise.resolve(res);
        });
}


export const userService = {
    login,
    forgotPassword,
    newPassword,
    resetPassword,
    teacherLogin,
    getTeacherToken,
}